(function() {
	'use strict';

	angular
		.module('diplomaApp')
		.filter('trim', trimFilter)
		.filter('find', findFilter)
		.filter('ceil', ceilFilter);

	function ceilFilter() {
		return function(value) {
			return Math.ceil(value);
		};
	}

	function trimFilter() {
		return function(value) {
	        if(!angular.isString(value)) {
	            return value;
	        }  
	        return value.replace(/^\s+|\s+$/g, ''); // you could use .trim, but it's not going to work in IE<9
	    };
	}

	function findFilter() {
		return function(arr, key, keyValue) {
			var ret = arr;
			var founded = false;

			if (arr === undefined || key === undefined || keyValue === undefined || !angular.isArray(arr)) {
				return arr;
			}

			angular.forEach(arr, function(val) {
				if (val[key] == keyValue) {
					ret = val;
					founded = true;
				}
			});

			if (founded) {
				return ret;
			} else {
				return false;
			}
			
		};
	}

}());